<div class="home-view">
    <div class="layout-default">
        <pm-resize-panel Orientation="Horizontal"
                         FirstElementFlexGrow=".3"
                         SecondElementFlexGrow=".7">

            <div class="layout-left-panel" 
                 resize-item-1>
                        
                <div class="controls-menu-header">
                    PM-Controls
                    <div class="controls-version-header">v {{Version}}</div>
                </div>
                
                <pm-list-box [ItemsSource]="Controls" 
                             [ItemTemplate]="ItemTemplate"
                             [ListBoxBorderClass]="'home-listbox-border'"
                             [ControlHeight]="'calc(100% - 100px)'"
                             ItemHeight="40">
                    <ng-template #ItemTemplate let-item>
                        <div class="home-item-template"
                             routerLink="{{item.Path}}" 
                             routerLinkActive="item-active">{{item.Name}}</div>
                    </ng-template>
                </pm-list-box>
            </div>
            <div class="layout-right-view"
                 resize-item-2
                 [style.height]="'100%'">
                <router-outlet></router-outlet>
            </div>
        </pm-resize-panel>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/home.html